<template>
  <div :class="checkboxClass" @click="onClick">

  </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        mode: String
    },
    methods: {
        onClick() {
            this.$emit('input', !this.value);
        }
    },
    computed: {
        checkboxClass() {
            return {
                'mode-checkbox': true,
                [`checkbox-${this.mode}`]: !!this.value
            }
        }
    }
}
</script>

<style scoped>
.mode-checkbox {
  width: 3.2vh;
  height: 3.2vh;

  background: #464646;

  border: 2px solid #464646;
  border-radius: 0.5vh;

  margin-right: 1.7vh;

  cursor: pointer;
}

.checkbox-preorder {
  background: #ffd2a8 !important;
}

.checkbox-delivery {
  background: #cbd9e6 !important;
}

.checkbox-reserve {
  background: #aeccc6 !important;
}
</style>